/* global Forms */

import ApplicationController from '../application_controller'

class TaskFormController extends ApplicationController {
  connect () {
    Forms.initSelect2(this.element)
    Forms.initDatePickers(this.element)
  }

  cancel () {
    const frame = document.getElementById('new_todo_task')
    if (frame) frame.remove()
  }
}

export default TaskFormController
